import { mlvApplyZ } from './mlvZLayers.js';
import { mlvSaveFocus } from './mlvFocusRestore.js';
import { mlvModalHistoryAttach } from '../navigation/mlvModalHistoryBridge.js';
import { openNegocioVecinoExplainer } from './negocioVecinoExplainer.js';

/**
 * Modal al alcanzar el tope de publicaciones activas (cupos free / premium).
 */
export function openModalLimitePublicaciones({
  esPremium = false,
  limiteActivas = 3,
  onActivarPremium,
  onIrMisPublicaciones,
} = {}) {
  return new Promise((resolve) => {
    const restoreFocus = mlvSaveFocus();
    const prev = document.getElementById('mlv-limite-pub-modal');
    if (prev) prev.remove();

    const n = Number(limiteActivas) || 3;
    const wrap = document.createElement('div');
    wrap.id = 'mlv-limite-pub-modal';
    wrap.className =
      'fixed inset-0 flex items-end justify-center bg-black/55 p-4 backdrop-blur-[2px] transition-opacity duration-200 sm:items-center';
    mlvApplyZ(wrap, 'limitePub');
    wrap.style.opacity = '0';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    wrap.setAttribute('aria-labelledby', 'mlv-limite-pub-title');

    const titleHtml = esPremium
      ? 'Llegaste al tope de tu plan'
      : `Tenés ${n} publicaciones activas`;

    const mainHtml = esPremium
      ? `<p class="mt-3 text-center text-sm leading-relaxed text-slate-700">Llegaste al <strong class="font-semibold text-slate-900">tope</strong> de tu plan Premium (<strong class="font-semibold text-slate-900">${n} activas</strong>). Liberá cupos con <strong class="font-semibold text-slate-800">¡Lo vendí!</strong> en Mis publicaciones o escribinos si necesitás más.</p>`
      : `<p class="mt-3 text-center text-sm leading-relaxed text-slate-700">Ya tenés el máximo de publicaciones <strong class="font-semibold text-slate-900">activas</strong> de tu plan. Liberá un cupo con <strong class="font-semibold text-slate-800">¡Lo vendí!</strong> o <strong class="font-semibold text-brand-primary">ampliá con Premium</strong>.</p>`;

    const btnMis =
      typeof onIrMisPublicaciones === 'function'
        ? `<button type="button" id="mlv-limite-pub-mis" class="w-full rounded-full bg-brand-primary py-3.5 text-sm font-bold text-white shadow-md transition hover:brightness-95">
              Ir a Mis publicaciones
            </button>`
        : '';

    const btnPremium =
      !esPremium
        ? `<button type="button" id="mlv-limite-pub-premium" class="w-full rounded-full border-2 border-brand-primary bg-white py-3 text-sm font-bold text-brand-primary transition hover:bg-brand-primary/5">
              Ver Plan Premium
            </button>`
        : '';

    wrap.innerHTML = `
      <div data-mlv-panel class="w-full max-w-md translate-y-3 scale-95 opacity-0 transition-all duration-300 ease-out sm:translate-y-0">
        <div class="rounded-3xl bg-white p-6 shadow-2xl ring-1 ring-slate-200/90">
          <div class="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-primary/10 text-brand-primary">
            <svg class="h-8 w-8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z" />
            </svg>
          </div>
          <h2 id="mlv-limite-pub-title" tabindex="-1" class="font-heading text-center text-lg font-bold leading-snug text-slate-900">${titleHtml}</h2>
          ${mainHtml}
          <div class="mt-6 flex flex-col gap-2.5">
            ${btnMis}
            ${btnPremium}
            <button type="button" id="mlv-limite-pub-como" class="w-full rounded-xl py-2.5 text-xs font-semibold text-brand-primary hover:underline">
              Ver cupos, nivel y comisión en detalle
            </button>
            <button type="button" id="mlv-limite-pub-ok" class="w-full rounded-full border border-slate-300 bg-white py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    `;

    const hist = mlvModalHistoryAttach(() => {
      document.removeEventListener('keydown', onKey);
      wrap.style.opacity = '0';
      const panel = wrap.querySelector('[data-mlv-panel]');
      if (panel) {
        panel.classList.add('translate-y-3', 'scale-95', 'opacity-0');
        panel.classList.remove('sm:translate-y-0');
      }
      setTimeout(() => {
        try {
          restoreFocus();
        } catch (_e) {
          /* ignore */
        }
        wrap.remove();
        resolve();
      }, 220);
    });

    function close() {
      hist.closeFromUi();
    }

    function onKey(e) {
      if (e.key === 'Escape') close();
    }

    document.addEventListener('keydown', onKey);
    wrap.addEventListener('click', (e) => {
      if (e.target === wrap) close();
    });

    document.body.appendChild(wrap);
    requestAnimationFrame(() => {
      wrap.style.opacity = '1';
      const panel = wrap.querySelector('[data-mlv-panel]');
      if (panel) {
        panel.classList.remove('translate-y-3', 'scale-95', 'opacity-0');
        panel.classList.add('scale-100', 'opacity-100');
      }
      wrap.querySelector('#mlv-limite-pub-title')?.focus?.({ preventScroll: true });
    });

    wrap.querySelector('#mlv-limite-pub-como')?.addEventListener('click', () => {
      void openNegocioVecinoExplainer({ section: esPremium ? 'premium' : 'cupos' });
    });
    wrap.querySelector('#mlv-limite-pub-ok')?.addEventListener('click', close);
    wrap.querySelector('#mlv-limite-pub-premium')?.addEventListener('click', () => {
      try {
        onActivarPremium?.();
      } finally {
        close();
      }
    });
    wrap.querySelector('#mlv-limite-pub-mis')?.addEventListener('click', () => {
      try {
        void onIrMisPublicaciones?.();
      } finally {
        close();
      }
    });
  });
}
